<template>
  <div class="table-container bj-small-card">
    <div v-if="showOperation" class="operation">
      <div class="title">{{ tableTitle }}</div>
      <div>
        <slot name="operation"></slot>
      </div>
    </div>
    <div class="btns-box">
      <slot name="btns"></slot>
    </div>
    <div class="btns-box right">
      <slot name="btns-right"></slot>
    </div>
    <el-table
      id="bj-table"
      ref="table"
      style="margin-top:4px;border-radius: 4px;"
      v-bind="tableBind"
      align="center"
      header-cell-class-name="table__header"
      border
      :max-height="maxHeight"
      stripe
      :header-cell-style="{ color: '#999' }"
      fit
      v-on="$listeners"
      header-align="center"
    >
      <slot />
    </el-table>
    <div class="pagination-container">
      <el-pagination
        v-if="showPagination"
        :small="small"
        class="pagination"
        background
        :current-page="pagination.pageIndex"
        :page-size="pagination.pageSize"
        :layout="layout"
        :page-sizes="pageSizes"
        :total="pagination.total"
        @size-change="onSizeChange"
        @current-change="search"
      />
      <slot name="batch" />
    </div>

  </div>
</template>
<script>
import { getOffsetTopByBody, debounce } from '@/utils';

export default {
  name: 'BjTable',
  components: {},
  props: {
    showPagination: {
      type: Boolean,
      default: () => true
    },
    small: {
      type: Boolean,
      default: () => false
    },
    layout: {
      type: String,
      default: () => 'prev, pager, next, sizes, total, jumper'
    },
    height: {
      type: Number,
      default: () => 0
    },
    showOperation: {
      type: Boolean,
      default: () => true
    },
    tableTitle: {
      type: String,
      default: () => ''
    },
    pageSize: {
      type: Number,
      default: () => 20
    }
  },
  data() {
    return {
      pagination: {
        pageIndex: 1,
        pageSize: 20,
        total: 0
      },
      maxHeight: 800
    };
  },
  computed: {
    pageSizes() {
      const sizes = [...new Set([this.pageSize, 10, 20, 50, 100])];
      return sizes.sort((a, b) => a - b);
    },
    tableBind() {
      const bind = {
        ...this.$attrs
      };
      if (this.height) {
        bind.height = this.height;
      }
      return bind;
    }
  },
  created() {
    this.pagination.pageSize = this.pageSize;
  },
  mounted() {
    this.search();
  },
  activated() {
    this.resizeHeight();
  },
  deactivated() {
    window.removeEventListener('resize', this.debounceHeight);
  },
  methods: {
    resizeHeight() {
      this.debounceHeight = debounce(this.getTableHeight, 1500, true);
      this.debounceHeight();
      window.addEventListener('resize', this.debounceHeight);
    },
    getTableHeight() {
      if (this.height) {
        return;
      }
      if (this.maxHeightProps) {
        this.maxHeight = this.maxHeightProps;
        return;
      }
      const offsetTop = getOffsetTopByBody(document.querySelector('#bj-table'));
      const windowHeight = document.documentElement.clientHeight;
      this.maxHeight = windowHeight - offsetTop - 20 - 52;
    },
    onSizeChange(size) {
      localStorage.setItem('pageSize', size);
      this.pagination.pageSize = size;
      this.search(1);
    },
    search(pageIndex) {
      if (pageIndex) {
        this.pagination.pageIndex = pageIndex;
      }
      this.$emit('search', this.pagination);
    },
    changePage(page) {
      this.pagination.pageIndex = page;
    }
  }
};
</script>
<style lang="less">
.el-table thead{

}
.el-table thead > tr > th {
    color:rgba(0, 0, 0, 0.85) !important;
    font-weight: 500;
    text-align: left;
    background: #fafafa;
    border-bottom: 1px solid #e8e8e8;
    -webkit-transition: background 0.3s ease;
    transition: background 0.3s ease;
}
</style>
<style lang="less" scoped>
.table-container{
  box-sizing: border-box;
  .operation{
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: bold;
    color: #262626;
    align-items: center;
    .title{
      border-left: 3px solid #0080F6;
      padding-left: 8px;
      line-height: 15px;
    }
  }
}
.pagination-container{
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: flex-end;
}
.btns-box{
  display: flex;
  &.right{
    justify-content: flex-end;
  }
}
.pagination{
  margin-top: 10px;
  padding-right: 0 i !important;
  background: #fff;
  display: flex;
  justify-content: flex-end;
  .btn-next{
    margin-right: 0 i !important;
  }
}
</style>
